// Sugalarm — web dashboard observational disclaimer (cycle 177).
//
// A full-width bar rendered at the top of the /dashboard canvas, above
// every panel. WEB FRAME ONLY — the dashboard itself is web-gated, so
// this never paints on kiosk/mobile. The wording is held in ONE exported
// constant so later cycles (patterns/insights, PDF reports) reuse the
// identical sentence rather than drifting a second copy.

import styles from "./DisclaimerBar.module.css";

/** The canonical observational disclaimer. It deliberately speaks to the
 *  WHOLE dashboard — the lows/highs counts, the live trend, the glucose
 *  profile, and any projection a later cycle adds — so one bar covers
 *  every panel. Reuse this constant verbatim anywhere the same notice is
 *  required (patterns, exported PDF reports); do not fork the wording. */
export const OBSERVATIONAL_DISCLAIMER =
  "Everything on this dashboard — the counts, the trend, the glucose " +
  "profile, and any projection — is observational and not medical advice. " +
  "Sugar Alarm is a secondary display: keep your CGM's own alarms on. If your " +
  "symptoms and the readings disagree, confirm with a fingerstick, and " +
  "always consult your care team before changing treatment.";

export function DisclaimerBar() {
  return (
    <div className={styles.bar} role="note">
      <svg
        className={styles.icon}
        viewBox="0 0 24 24"
        fill="none"
        aria-hidden="true"
      >
        <circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5" />
        <path
          d="M12 11v5"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <circle cx="12" cy="8" r="1" fill="currentColor" />
      </svg>
      {/* Plain text node — never innerHTML; no member-derived content. */}
      <span className={styles.text}>{OBSERVATIONAL_DISCLAIMER}</span>
    </div>
  );
}
